var map = {
	"./check.svg": 2497,
	"./error.svg": 5119,
	"./facebook.svg": 3479,
	"./instagram.svg": 5373,
	"./line.svg": 8361,
	"./loading.svg": 7649,
	"./omise.png": 8624,
	"./omise.svg": 9104,
	"./opn-payments.svg": 4528,
	"./pending.svg": 7352,
	"./subtract.svg": 5503
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5853;